/**
 * 應用程式上下文
 * 管理全局應用狀態和適配器實例
 */

import React, { createContext, useContext, useMemo } from 'react';
import { getAdapter } from '../adapters/adapterFactory';

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  // 獲取適配器實例（使用 useMemo 確保只創建一次）
  const adapter = useMemo(() => getAdapter(), []);

  const value = useMemo(() => ({
    adapter,
  }), [adapter]);

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
};

